import React from 'react';
import { Box, Container, Flex, Heading, SimpleGrid, Stack, Tag, Text } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { MdArrowForward } from 'react-icons/md';
import { useTranslation } from 'i18n';
import { PLATFORMS } from './integrations/data';
import { localizePlatform } from './integrations/i18n';

// Overview tại /integrations — list 8 platform card, mỗi card link sang
// /integrations/<slug>. Live vs Coming soon phân biệt bằng badge.
export default function IntegrationsIndex() {
  const { lang, t } = useTranslation();

  return (
    <Box>
      <Box
        bgGradient="linear(to-br, blue.50, purple.50)"
        py={{ base: 12, md: 16 }}
        borderBottom="1px solid"
        borderColor="gray.100"
      >
        <Container maxW="container.xl" px={{ base: 4, md: 6 }} textAlign="center">
          <Tag size="sm" colorScheme="blue" borderRadius="full" px={3} mb={3}>
            <Text fontSize="xs" fontWeight="600">
              {t('integrations.badge')}
            </Text>
          </Tag>
          <Heading fontSize={{ base: '2xl', md: '4xl' }} fontWeight={800} color="gray.900" mb={3}>
            {t('integrations.title')}
          </Heading>
          <Text color="gray.600" maxW="2xl" mx="auto">
            {t('integrations.subtitle')}
          </Text>
        </Container>
      </Box>

      <Container maxW="container.xl" px={{ base: 4, md: 6 }} py={{ base: 12, md: 16 }}>
        <SimpleGrid columns={{ base: 1, sm: 2, lg: 3 }} spacing={{ base: 4, md: 5 }}>
          {PLATFORMS.map(base => {
            const p = localizePlatform(base, lang);
            const PIcon = p.icon;
            const isLive = (p.screenshots?.length || 0) > 0;
            const taglineKey = `platform.${p.slug}.tagline`;
            const tagline = t(taglineKey);
            return (
              <Flex
                key={p.slug}
                as={RouterLink}
                to={`/integrations/${p.slug}`}
                bg="white"
                border="1px solid"
                borderColor="gray.100"
                borderRadius="16px"
                p={{ base: 5, md: 6 }}
                direction="column"
                position="relative"
                transition="all 0.2s"
                _hover={{
                  transform: 'translateY(-4px)',
                  boxShadow: 'xl',
                  borderColor: `${p.color}30`,
                  textDecoration: 'none',
                }}
              >
                <Flex justify="space-between" align="flex-start" mb={4}>
                  <Flex
                    w="56px"
                    h="56px"
                    borderRadius="14px"
                    bg={`${p.color}15`}
                    align="center"
                    justify="center"
                    color={p.color}
                  >
                    <PIcon size={26} />
                  </Flex>
                  <Tag
                    size="sm"
                    colorScheme={isLive ? 'green' : 'gray'}
                    borderRadius="full"
                    fontSize="10px"
                    fontWeight={700}
                  >
                    {isLive ? t('integrations.status.live') : t('integrations.status.coming')}
                  </Tag>
                </Flex>
                <Heading fontSize="lg" fontWeight={700} color="gray.900" mb={1}>
                  {p.name}
                </Heading>
                <Text fontSize="xs" color="gray.500" mb={3}>
                  {tagline === taglineKey ? p.tagline : tagline}
                </Text>
                <Text fontSize="sm" color="gray.600" lineHeight="1.6" noOfLines={3} mb={4}>
                  {p.description}
                </Text>

                <Stack spacing={2} mt="auto">
                  <Flex gap={1.5} flexWrap="wrap">
                    {p.products.slice(0, 3).map(prod => (
                      <Tag
                        key={prod}
                        size="sm"
                        colorScheme="blue"
                        borderRadius="md"
                        fontSize="10px"
                        fontWeight={600}
                      >
                        {prod}
                      </Tag>
                    ))}
                  </Flex>
                  <Flex
                    align="center"
                    color="blue.500"
                    fontSize="xs"
                    fontWeight={600}
                    gap={1}
                    pt={1}
                  >
                    <Text>{t('integrations.learnMore')}</Text>
                    <MdArrowForward />
                  </Flex>
                </Stack>
              </Flex>
            );
          })}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
